/* eslint-disable no-unused-vars */
import * as React from "react";
/* eslint-enable no-unused-vars */
import { connect } from "react-redux";
import { IApplicationState } from "../../models/store/storeTypes";
import * as storeEffects from "../../models/store/storeEffects";
import { IDocumentPageOwnProps, IDocumentPageStateProps, IDocumentPageDispatchProps, DocumentPage } from "../../components/document/DocumentPage/DocumentPage";
import { ITypedOption } from "../../models/common/typedOption";
import { DocumentThunkDispatch, getDocumentPage } from "source/models/store/document/storeDocumentEffects";

export function mapStateToProps(applicationState: IApplicationState, ownProps: IDocumentPageOwnProps): IDocumentPageStateProps {
    if (!applicationState || !applicationState.front) {
        return {
            appState: null,
            dataId: -1,
            documentPage: null
        };
    }
    const document = applicationState.document;
    return {
        appState: applicationState.session,
        dataId: document.page.dataId,
        documentPage: document.page.documentPage
    };
}

export function mapDispatchToProps(dispatch: DocumentThunkDispatch): IDocumentPageDispatchProps {
    return {
        onGetDocumentPage: () => dispatch(getDocumentPage()),
        onLogout: () => dispatch(storeEffects.logout()),
        onSetCulture: (culture: string) => dispatch(storeEffects.setCulture(culture)),
        onSaveUserParameters: (parameters: ITypedOption[]) => dispatch(storeEffects.saveUserParameters(parameters)),
        onRefreshSessionState: () => dispatch(storeEffects.refreshSessionState()),
    };
}

export default connect<IDocumentPageStateProps, IDocumentPageDispatchProps, IDocumentPageOwnProps>(mapStateToProps, mapDispatchToProps)(DocumentPage);